

































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";

import { Grupo } from "@/store/grupos/models";
import { IVessel } from "@/store/targets/models";

import { IHeaders } from "../tables/interfaces";


// 👇 IMPORTANTE: contexto del módulo
import { grupos } from "@/store";
import { Blanco } from "@/store/grupos/models";

import { targets } from "@/store";

@Component
export default class ManageGruposDialog extends Vue {

  dialog: boolean = false;

  // ========================
  // 🧠 STORE (vuex-smart-module)
  // ========================

  mounted() {
    grupos.actions.fetchGrupos();
  }

  get gruposList(): Grupo[] {
    return grupos.getters.grupos;
  }

  get loading(): boolean {
    return grupos.getters.loading;
  }

  // ========================
  // 🎨 UI HELPERS
  // ========================

  formatFecha(fecha: string): string {
    return new Date(fecha).toLocaleString();
  }
  /*
  hexToRgba(hex: string): string {
    console.log("Colore: " + hex);
    if (hex.length === 9) {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      const a = parseInt(hex.slice(7, 9), 16) / 255;
      return `rgba(${r}, ${g}, ${b}, ${a})`;
    }
    return hex;
  }
  */
hexToRgba(hex: string): string {
  if (hex.length === 9) {
    // #AARRGGBB → separar
    const a = hex.slice(1, 3)
    const r = hex.slice(3, 5)
    const g = hex.slice(5, 7)
    const b = hex.slice(7, 9)

    const alpha = parseInt(a, 16) / 255

    return `rgba(${parseInt(r,16)}, ${parseInt(g,16)}, ${parseInt(b,16)}, ${alpha})`
  }

  return hex
}

  getTextColor(hex: string): string {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);

    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 150 ? "#000" : "#fff";
  }

  cardStyle(color: string) {
    return {
      backgroundColor: this.hexToRgba(color),
      color: this.getTextColor(color),
      cursor: "pointer",
    };
  }

  // ========================
  // ⚙️ ACCIONES (UI)
  // ========================

  selectGrupo(grupo: Grupo) {
    this.selectedGrupo = grupo
  }

  editGrupo(grupo: Grupo) {
    this.selectedGrupo = grupo
  }

  async deleteGrupo(grupo: Grupo) {
    const confirmacion = confirm(`¿Eliminar el grupo "${grupo.nombre}"?`)

    if (!confirmacion) return

    try {
      await grupos.actions.deleteGrupo(grupo.id)

      console.log("✅ Grupo eliminado")

    } catch (error) {
      console.error("❌ Error eliminando grupo", error)
    }
  }
  /*
  addBlanco(grupo: Grupo) {
    this.selectedGrupo = grupo
  }
  */
  // crear grupo
  showCreateDialog: boolean = false;

  newGrupo = {
    nombre: "",
    informacion: "",
    color: "#FFFFFF"
  };

  // 🎨 Paleta fija
  colores = [
    "#FFFFFF",
    "#FFFFF000",
    "#FFC500FF",
    "#FF00FF3D",
    "#FFFF6500",
    "#FFF10000",
    "#FF43DDFF",
    "#FFD166FF",
    "#FF039E12",
    "#FF787878",
    "#000000"
  ];

  async saveGrupo() {
    if (!this.newGrupo.nombre) {
      alert("El nombre es obligatorio");
      return;
    }

    // 👉 siguiente paso: conectar con store
    // grupos.actions.createGrupo(this.newGrupo)

    await grupos.actions.createGrupo(this.newGrupo)

    // reset
    this.newGrupo = {
      nombre: "",
      informacion: "",
      color: "#FFFFFF"
    };

    this.showCreateDialog = false;
  }

  // blancos
  headers: IHeaders[] = [
    {
      text: "MMSI",
      align: "start",
      sortable: false,
      value: "mmsi",
    },
    { text: "Nombre", value: "statics.name" },
  ];

  headersBlancos = [
  { text: "MMSI", value: "MMSI" },
  { text: "Nombre", value: "ShipName" },
]

  selectedGrupo: Grupo | null = null
  selectedTarget: IVessel | null = null
  selectedGrupoBlanco: any = null

  get grupoBlancos(): any[] {
    if (!this.selectedGrupo) return []
    
    //return Object.values(this.selectedGrupo.blancos || {})
    return this.selectedGrupo.blancosArray || []

  }

  get targetsList(): IVessel[] {
    return targets.getters.vesselList // ajusta según tu store
  }


  mapTargetToBlanco(target: IVessel): Blanco {
  return {
    MMSI: target.mmsi,
    ShipName: target.statics.name,
    Lat: 0,
    Lon: 0,
    Speed: target.speed,
    Course: target.course,
  }
}

  async addTargetToGrupo() {
    if (!this.selectedGrupo || !this.selectedTarget) return

    const grupo = this.selectedGrupo

    const nuevoBlanco = this.mapTargetToBlanco(this.selectedTarget)


    const nuevosBlancos = {
      ...grupo.blancos,

      // 🔥 clave: MMSI como índice
      [nuevoBlanco.MMSI]: nuevoBlanco
    }

    
    
    await grupos.actions.updateGrupo({
      id: grupo.id,
      nombre: grupo.nombre,
      informacion: grupo.informacion,
      color: grupo.color,

      // 👇 aquí pasamos blancos completos
      blancos: nuevosBlancos
    })

    // refrescar local
    //this.selectedGrupo.blancos = nuevosBlancos

    grupo.blancos = nuevosBlancos
    grupo.blancosArray = Object.values(nuevosBlancos)


    this.selectedTarget = null
    this.selectedGrupoBlanco = null

  }

  async removeBlanco() {
    if (!this.selectedGrupo || !this.selectedGrupoBlanco) return

    const grupo = this.selectedGrupo
    const mmsi = this.selectedGrupoBlanco.MMSI

    const nuevosBlancos = { ...grupo.blancos }

    delete nuevosBlancos[mmsi]

    await grupos.actions.updateGrupo({
      id: grupo.id,
      nombre: grupo.nombre,
      informacion: grupo.informacion,
      color: grupo.color,
      blancos: nuevosBlancos
    })

    //this.selectedGrupo.blancos = nuevosBlancos
    grupo.blancos = nuevosBlancos
    grupo.blancosArray = Object.values(nuevosBlancos)

  }

}
